<template>
<div id="customaddress">
  <v-app id="customaddressapp">
    <v-row justify="center">
      <v-dialog v-model="dialog" content-class="info-dialog">
        <v-card>
          <v-card-title>
            <h4>{{$t('custom_address')}}</h4>
          </v-card-title>
          <v-card-text>
            <v-row > 
              <!-- <v-col  cols="12" class="pb-0 subtitle-1"><b></b></v-col> -->
              <v-col  cols="12" class="pb-0"><br>
                <ol>
                  <li>{{$t('custom_address_connect')}}</li>
                  <li>{{$t('custom_address_choose')}}</li>
                  <li>{{$t('custom_address_define')}}</li>
                </ol><br>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="login">{{$t('custom_address_starten')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</div>
</template>

<script>
export default {
  name: 'Customaddress',
  data () {
    return {
      dialog: false,
    }
  },
  props: [ 'showLoginDialog' ],
  computed: {
  },
  methods: {
    login(){
        this.showLoginDialog(true)
    },
    back() {
      return true
    },
    openDialog(){
      this.dialog = true
    },
    closeDialog(){
      this.dialog = false
    }
  }

}
</script>

